import styled from 'styled-components/macro';
import { COLORS } from 'utils/styles/colors';
import { deviceMax } from 'utils/styles/breakpoints';
import { FONT_FAMILY, FONTS } from 'utils/styles/fonts';
import { FLEX_CONTAINER } from 'utils/styles/flex';

export const FooterContainer = styled.div`
  ${FLEX_CONTAINER.FlexSpaceBetweenColumn}
  background: ${COLORS.multiGray};

  @media only screen and ${deviceMax.desktop} {
    flex-wrap: wrap;
    height: auto;
    padding: 20px;
  }

  @media only screen and ${deviceMax.laptopLMax} {
    padding: 20px 80px;
  }

  @media only screen and ${deviceMax.mobileXL} {
    padding: 20px;
  }
`;

export const FooterMainContent = styled.div`
  ${FLEX_CONTAINER.FlexRow};
  flex-wrap: wrap;
  align-items: start;
  row-gap: 50px;
  column-gap: 120px;

  @media only screen and ${deviceMax.laptopLMax} {
    column-gap: 80px;
    justify-content: space-between;
  }
`;

export const FooterFilters = styled.div`
  ${FLEX_CONTAINER.FlexColumn};
  align-items: start;
  gap: 20px;
  width: auto;
  height: 100%;

  a {
    color: unset;
  }

  @media only screen and ${deviceMax.tablet} {
    width: 100%;
  }
`;

export const SectionTitle = styled.span`
  ${FLEX_CONTAINER.FlexRow}
  ${FONTS.font16}
  color: ${COLORS.black};
  ${FONT_FAMILY.FontBold}
  text-transform: capitalize;
`;

export const SpanWithNoStyle = styled.span``;

export const SocialMediaIcons = styled.div`
  ${FLEX_CONTAINER.FlexRow}
  gap: 20px;
  width: 100%;
`;

export const LinkToSocialMedia = styled.a``;

export const SocialMediaIcon = styled.img`
  cursor: pointer;

  &:hover {
    filter: brightness(0) saturate(100%) invert(18%) sepia(76%) saturate(593%) hue-rotate(156deg) brightness(97%) contrast(93%);
    opacity: 0.7;
  }
`;

export const SubscribeBlock = styled.div`
  ${FLEX_CONTAINER.FlexCenterColumn};
`;

export const EmailAddressInput = styled.input`
  width: 168px;
  padding: 10px;
  outline: none;
  color: ${COLORS.mainColor};
  border: 1px solid ${COLORS.mainColor};
  border-radius: 8px 0px 0px 8px;

  ::placeholder {
    color: ${COLORS.mainColor};
  }
`;

export const EmailAddressSendButton = styled.button`
  width: 85px;
  padding: 11px;
  background: ${COLORS.mainColor};
  color: ${COLORS.white};
  border-radius: 0px 8px 8px 0px;
`;

export const CopyrightITAHText = styled.span`
  text-align: center;
  padding-top: 30px;
`;
